const axios = require('axios')


function check_variabili_oggetto(obj, ...args) {
    return args.reduce((obj, level) => obj && obj[level], obj)
  }
// const { Controlla_se_lavoro_in_debug } = require('../Funzioni_comuni')
// fondamentale per il debug        {/* idroslab  */}



function Controlla_se_lavoro_in_debug (user) {
let debug = false
let email_google = check_variabili_oggetto (user, 'email')  
  
    if (email_google === 'paolosordi12@gmail.com' ||
        email_google === 'dirigente@ipsiapacinotti.it' ||
        email_google === 't.fogli@ipsiapacinotti.it')  {
         
          debug=true
    }
 
    return debug
}
exports.Controlla_se_lavoro_in_debug = Controlla_se_lavoro_in_debug;


